import * as React from 'react';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import { connect } from 'react-redux';
import { Validators, DatePickerRangeField } from './Fields/_Fields';
import { withTranslation  } from 'react-i18next';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import {compose} from 'redux';
import {Dropdown} from "components/Layout/Dropdown/Dropdown.Component";
import * as VehicleActions from "Redux/Actions/VehicleActions";
import RenderField from "components/Layout/Form/Fields/RenderField";

type ConnectedProps = {
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
    t: Function;
  downloadTraceHistoryToXLSX: () => void
};

const LatestDataframesForm = (props: InjectedFormProps & ConnectedProps) => {
  const {
      handleSubmit,
      submitting,
      // @ts-ignore
      clearSubmit,
      t,
      downloadTraceHistoryToXLSX
    } = props;

  const options = React.useMemo(() => [
    {
      content: t('forms:GET_TRACE_AS_EXCEL'),
      id: "GET_TRACE_AS_EXCEL",
      onClick: downloadTraceHistoryToXLSX
    }
  ], [downloadTraceHistoryToXLSX])

    return (
        <form className="form" onSubmit={handleSubmit}>
            <Field
                name="dateRange"
                component={DatePickerRangeField}
                type="text"
                placeholder={t('dateRange')}
                label={t('dateRange')}
                validate={[Validators.required]}
                endDateLabel={t('endDate')}
                startDateLabel={t('startDate')}
                additionalComponent={<Dropdown
                  id="get-trace-menu"
                  label={t('GET_TRACE_AS')}
                  options={options}
                />}
                wrapperClassName="search-rides-date-picker"
            />
            <Field
              name="fullTrace"
              id="fullTrace"
              component={RenderField}
              type="checkbox"
              label={t('GET_FULL_TRACE')}
              wrapperClassName="search-rides-full-trace"
            />
            <button disabled={submitting} className="btn btn--blue" type="submit">
                {t('generate')}
            </button>
        </form>
    );
};

function mapStateToProps(state: any) {
    return {
        viewManagementStore: state.viewManagementStore.activeLanguage
    };
}

function mapDispatchToProps(dispatch: any) {
  return {
    downloadTraceHistoryToXLSX: () => dispatch(VehicleActions.downloadTraceHistoryToXLSX())
  }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withTranslation (['forms', 'errors']),
    reduxForm({
        form: 'latestDataframesForm',
        enableReinitialize: true,
        keepDirtyOnReinitialize: true
    })
)(LatestDataframesForm) as React.ComponentClass<any>



// WEBPACK FOOTER //
// ./src/components/Layout/Form/LatestDataframesForm.tsx